import React, { useEffect, useState } from "react";
import { TdsInfoType, TdsRateType } from "../../../commonTypes/masterDataTypes";
import { RadioContainer, RollingLoader } from "../../commons";
import {
  DEDUCTEE_TYPE_RADIO_OPTIONS,
  RESIDENTIAL_TYPE_RADIO_OPTIONS,
  SINGLE_TDS_RATE,
} from "../../../constant/master";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon, PlusIconCircle } from "../../Icon";
import { RedDeleteIcon } from "../../../assets/images";
import {
  handleDate,
  returnInputFieldLength,
} from "../../../utils/commonFunctions";
import "./style.scss";

type AppProps = {
  history: any;
  header: string;
  subHeader: string;
  handleSubmit: () => void;
  tdsData: any;
  setTdsData: React.Dispatch<React.SetStateAction<TdsInfoType>>;
  codeFetching: boolean;
  codeMessage: string;
};

const AddEditTdsMaster = ({
  handleSubmit,
  tdsData,
  setTdsData,
  history,
  header,
  subHeader,
  codeFetching,
  codeMessage,
}: AppProps) => {
  const searchValue = history?.location?.state?.searchValue;
  const sortBy = history?.location?.state?.sortBy;
  const [excludeDates, setExcludeDates] = useState<Date[] | []>([]);

  useEffect(() => {
    if (tdsData?.tdsRates) {
      let dates: any = [];
      tdsData?.tdsRates?.map((item: TdsRateType) => {
        let splittedDate = item?.tds_date?.split("-");
        dates.push(
          new Date(+splittedDate[2], +splittedDate[1] - 1, +splittedDate[0])
        );
      });
      setExcludeDates([...dates]);
    }
  }, [tdsData?.tdsRates]);

  const handleInputChange = (e: any) => {
    let name = e?.target?.name;
    let value = e?.target?.value;

    setTdsData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleGoBack = () => {
    history?.push({
      pathname: `/master-data/tds-and-tcs-master`,
      state: header === "Add New TDS Rate" ? {} : { searchValue, sortBy },
    });
  };

  const handleDateChange = (date: string, index: number) => {
    let newTdsRates = JSON.parse(JSON.stringify(tdsData?.tdsRates));
    let finalTdsRates = newTdsRates?.map((item: any, i: number) =>
      index === i ? { ...item, tds_date: date } : item
    );
    setTdsData((prev: TdsInfoType) => ({ ...prev, tdsRates: finalTdsRates }));
  };

  const handleTdsRateInputChange = (e: any, index: number) => {
    let newTdsRates = JSON.parse(JSON.stringify(tdsData?.tdsRates));

    let finalTdsRates = newTdsRates?.map((item: any, i: number) =>
      index === i ? { ...item, tds_rate: e?.target?.value } : item
    );
    setTdsData((prev: TdsInfoType) => ({ ...prev, tdsRates: finalTdsRates }));
  };

  const handleAddMoreRow = () => {
    let newTdsRates = JSON.parse(JSON.stringify(tdsData?.tdsRates));
    newTdsRates?.push(SINGLE_TDS_RATE);
    setTdsData((prev: TdsInfoType) => ({ ...prev, tdsRates: newTdsRates }));
  };

  const handleDeleteRow = (index: number) => {
    let newTdsRates = JSON.parse(JSON.stringify(tdsData?.tdsRates));
    const updatedTdsRates = newTdsRates.filter(
      (_: any, i: number) => i !== index
    );
    setTdsData((prev: TdsInfoType) => ({ ...prev, tdsRates: updatedTdsRates }));
  };

  const handleSetRadioValue = (value: string) => {
    setTdsData((prev: TdsInfoType) => ({ ...prev, deducteType: value }));
  };

  const handleSetResidentRadioValue = (value: string) => {
    setTdsData((prev: TdsInfoType) => ({ ...prev, residentialStatus: +value }));
  };

  const handleDeducteeCheckBox = (e: any) => {
    let checked = e?.target?.checked;
    let name = e?.target?.name;
    if (name === "Company") {
      setTdsData((prev: TdsInfoType) => ({
        ...prev,
        deducte: { ...prev.deducte, [name]: checked },
        deducteType: "Domestic",
      }));
    } else {
      setTdsData((prev: TdsInfoType) => ({
        ...prev,
        deducte: { ...prev.deducte, [name]: checked },
      }));
    }
  };

  const handleCollectionCodeInputChange = (e: any) => {
    let name = e?.target?.name;
    let value = e?.target?.value?.toUpperCase();

    setTdsData((prev: any) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="tds_master jobs-card">
      <div className="header pt-4">{header}</div>
      <div className="sub_heading">{subHeader}</div>

      <div className="section_header pt-4">BASIC DETAILS</div>
      <div className="row">
        {header !== "Add New TDS Rate" ? (
          <div className="col-md-2">
            <label htmlFor="uniqueId">Unique ID</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                disabled={true}
                className={`form-control`}
                name="uniqueId"
                value={tdsData?.uniqueId}
                onChange={handleInputChange}
              />
            </div>
          </div>
        ) : null}
        <div className="col-md-2">
          <label htmlFor="sectionName">
            Section Name <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className={`form-control`}
              name="sectionName"
              value={tdsData?.sectionName}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="col-md-4">
          <label htmlFor="natureOfPayment">
            Nature of Payment <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative">
            <textarea
              className={`form-control`}
              name="natureOfPayment"
              value={tdsData?.natureOfPayment}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="">
          <label htmlFor="threshold">Code</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className={`form-control ${
                !!codeMessage?.includes("Code already exists")
                  ? "error-border"
                  : null
              }`}
              name="code"
              value={tdsData?.code ? tdsData?.code : ""}
              onChange={handleCollectionCodeInputChange}
              style={{ width: "250px" }}
              maxLength={10}
              // onKeyPress={handleKeyPress}
            />
            {codeFetching && <RollingLoader />}
          </div>
          {codeMessage?.includes("Code already exists") && (
            <>
              <small className="text-danger">{codeMessage}</small>
              <br></br>
            </>
          )}
          <span className="input-length">
            {returnInputFieldLength(tdsData?.code?.length, 10)}
          </span>
        </div>
      </div>

      <div className="section_header">OTHER DETAILS</div>
      <div className="row">
        <div className="col-md-6 pl-3">
          <label htmlFor="work" className="mb-1">
            Residential Status{" "}
          </label>
          <div className="mt-2 d-flex align-items-center">
            <RadioContainer
              optionsList={RESIDENTIAL_TYPE_RADIO_OPTIONS}
              handleSetRadioValue={handleSetResidentRadioValue}
              radioValue={
                tdsData?.residentialStatus
                  ? tdsData?.residentialStatus?.toString()
                  : "0"
              }
              alignment="horizontal"
            />
          </div>
        </div>
      </div>

      <div className="row mb-4 mt-3">
        <div className="col-md-2">
          <label htmlFor="">Deductee</label>
          <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
            <input
              type="checkbox"
              name="Individual"
              style={{
                width: "19px",
                height: "19px",
                backgroundColor: "red",
                accentColor: " #dd4433",
              }}
              onChange={handleDeducteeCheckBox}
              className="checkbox"
              checked={tdsData?.deducte?.Individual}
            />
            <div>
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Individual
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-2 mt-4">
          <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
            <input
              type="checkbox"
              name="Company"
              style={{
                width: "19px",
                height: "19px",
                backgroundColor: "red",
                accentColor: " #dd4433",
              }}
              onChange={handleDeducteeCheckBox}
              className="checkbox"
              checked={tdsData?.deducte?.Company}
            />
            <div>
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Company
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-2 mt-4">
          <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
            <input
              type="checkbox"
              name="HUF"
              style={{
                width: "19px",
                height: "19px",
                backgroundColor: "red",
                accentColor: " #dd4433",
              }}
              onChange={handleDeducteeCheckBox}
              className="checkbox"
              checked={tdsData?.deducte?.HUF}
            />
            <div>
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                HUF
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-2 mt-4">
          <div className="d-flex align-items-start justify-content-start mt-3 mb-2 ">
            <input
              type="checkbox"
              name="Others"
              style={{
                width: "19px",
                height: "19px",
                backgroundColor: "red",
                accentColor: " #dd4433",
              }}
              onChange={handleDeducteeCheckBox}
              className="checkbox"
              checked={tdsData?.deducte?.Others}
            />
            <div>
              <small
                className="ml-2"
                style={{ fontSize: "14px", color: "#262a44" }}
              >
                Others
              </small>
            </div>
          </div>
        </div>
      </div>

      {tdsData?.deducte?.Company ? (
        <div className="row mb-4">
          <div className="col-md-4">
            <label htmlFor="work" className="mb-1">
              Company Status{" "}
            </label>
            <div className="mt-2 d-flex align-items-center">
              <RadioContainer
                optionsList={DEDUCTEE_TYPE_RADIO_OPTIONS}
                handleSetRadioValue={handleSetRadioValue}
                radioValue={tdsData?.deducteType ? tdsData?.deducteType : ""}
                alignment="horizontal"
              />
            </div>
          </div>
        </div>
      ) : null}

      <div className="row mb-4">
        <div className="col-md-3">
          <label htmlFor="threshold">Threshold</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="number"
              className={`form-control`}
              name="threshold"
              value={tdsData?.threshold ? tdsData?.threshold : ""}
              onChange={handleInputChange}
              onWheel={(event) => event.currentTarget.blur()}
            />
          </div>
        </div>
      </div>

      <div className="section_header">TAX RATES</div>

      {tdsData?.tdsRates?.map((item: TdsRateType, index: number) => {
        return (
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor="passportExpiry">
                Date <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <div className="date-picker-wraper mr-0 w-100">
                  <Label className="mr-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      disabled={item?.isEdit}
                      excludeDates={excludeDates}
                      selected={
                        item?.tds_date
                          ? new Date(
                              moment(
                                `${item?.tds_date}T00:00:00`,
                                "DD-MM-YYYY"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) => {
                        let tdsDate = handleDate(moment(e)).format(
                          "DD-MM-YYYY"
                        );
                        handleDateChange?.(
                          tdsDate && tdsDate != "Invalid date" ? tdsDate : "",
                          index
                        );
                      }}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      // disabled={!isEdit}
                      name="date_of_birth"
                      placeholderText="Select"
                      className="form-control"
                    />
                    <span
                      className="calender-icon"
                      style={{ right: "20px", top: "10px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <label htmlFor="email">
                Tax Rate % <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <input
                  type="number"
                  className={`form-control`}
                  name="taxRates"
                  disabled={item?.isEdit}
                  value={item?.tds_rate ? item?.tds_rate : ""}
                  onChange={(e: any) => handleTdsRateInputChange(e, index)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>

            {index > 0 && !item?.isEdit ? (
              <div
                className="col-md-1 mt-4 pointer "
                onClick={() => handleDeleteRow(index)}
              >
                <div className="tds_delete">
                  <img src={RedDeleteIcon} alt="delete" />
                </div>
              </div>
            ) : null}
          </div>
        );
      })}

      <div className="row mt-1 mb-1 mt-4">
        <div className="col-12">
          <button
            className="btn btn-sm btn-outline pointer"
            onClick={() => handleAddMoreRow()}
          >
            <PlusIconCircle />
            <span className="ml-2">Add More Row</span>
          </button>
        </div>
      </div>

      <div className="tds_footer">
        <div className="tds_line"></div>

        <div className="mt-4 d-flex justify-content-end">
          <button
            className="btn pointer"
            onClick={() => handleGoBack()}
            style={{ border: "1px solid #bfcbe1" }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary ml-3 pr-4 pl-4"
            onClick={() => handleSubmit()}
            disabled={codeMessage?.includes("Code already exists")}
          >
            {header === "Edit New TDS Rate" ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditTdsMaster;
